<template>
  <div id="content-page" class="content-page">
    <div class="iq-top-navbar" v-if="interactive.id">
      <div class="iq-navbar-custom">
        <nav class="navbar navbar-expand-lg navbar-light p-0">
          <router-link :to="homeURL">
            <img v-if="defaultAvatarLogo" :src="fileLogo" class="top-logo" />
            <img v-else class="top-logo" v-bind:src="'data:image/jpeg;base64,' + fileLogo" />
          </router-link>
        </nav>
      </div>
    </div>
    <b-container fluid>
      <iq-card v-if="interactive.id">
        <template v-slot:headerTitle>
          <h4 class="card-title title-typography-color">
            <i class="fas fa-star-half-alt"></i> Sesión interactiva
          </h4>
        </template>
        <template v-slot:headerAction>

        </template>
        <b-card-text>
          <b-container>
            <ot-subscriber v-if="agentStream" @error="errorHandler" :stream="agentStream" :session="session"
              :opts="subscriberOpts">
            </ot-subscriber>
            <p stype="min-height: 800px;" v-else>
              Esperando a que se conecte el profesional.
            </p>
          </b-container>
        </b-card-text>
      </iq-card>
      <iq-card v-if="interactive.id">
        <template v-slot:headerTitle>
          <h4 class="card-title title-typography-color">
            <i class="fas fa-star-half-alt"></i> Chat
          </h4>
        </template>
        <b-card-text>
          <b-container>
            <div class="message-container" style="max-height: 200px; overflow-y: auto;">
              <div v-for="(message, index) in messages" :key="index" class="p-2 my-2 rounded bg-light">
                <div class="message-header">
                  <strong>{{ message.role }}</strong> <span class="text-muted">{{ message.email }}</span>
                </div>
                <div class="message-body mt-2">
                  {{ message.message }}
                </div>
              </div>
            </div>
            <b-form @submit.prevent="sendMessage">
              <b-input-group class="mt-3">
                <b-form-input v-model="newMessage" placeholder="Escribe un mensaje..."></b-form-input>
                <b-input-group-append>
                  <b-button variant="success" type="submit">Enviar</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form>
          </b-container>
        </b-card-text>
      </iq-card>
      <b-modal id="modal-interactive-user-code" centered @ok="getPublic" @hide-header-close="true" no-close-on-backdrop
        no-close-on-esc>
        <template #modal-ok>Entrar</template>
        <template #modal-title>Acceder a la sesión interactiva</template>
        <b-form-group label="Email: *" label-for="email">
          <b-form-input id="email" v-model="email" type="text"></b-form-input>
        </b-form-group>
        <b-form-group label="Código acceso: *" label-for="code">
          <b-form-input id="code" v-model="code" type="text"></b-form-input>
        </b-form-group>
        <router-link class="iq-waves-effect pr-4"
          :to="{ path: '/public/interactive/payment', query: { interactiveId: interactiveId } }">Recupera u obtenga un
          nuevo código</router-link>
      </b-modal>

    </b-container>
  </div>
</template>
<script>
import routes from "../../router/index";
import organizationService from "../../services/organization";
import interactiveService from "../../services/interactive";
import utilsService from "../../services/utils";
import OtSubscriber from '../../components/opentok/ot-subscriber';

import OT from '@opentok/client';

export default {
  name: "RecipePublic",
  components: { OtSubscriber },
  mounted() {
    this.$bvModal.show("modal-interactive-user-code");
    this.getLogoOrganization();

    // this.checkCode();
    // this.getPdfByToken();
    // this.getByToken();
  },
  data() {
    return {
      interactive: {},
      interactiveId: this.$route.query.interactiveId,
      homeURL: {
        type: Object,
        default: () => ({ name: "public.singin" }),
      },
      file: "",
      defaultAvatarLogo: true,
      fileLogo: "",
      code: "",
      email: "",
      //Call
      agentConnected: false,
      caller: null,
      session: null,
      agentStream: null,
      subscriberOpts: {
        insertMode: 'append',
        width: '100%',
        height: '100%',
      },
      callerName: null,
      callerReason: null,
      audioVideo: 'audioVideo',
      newMessage: '',
      messages: [],
    };
  },
  methods: {
    async otConnect(apiKey, sessionId, token) {
      let self = this;
      this.session = OT.initSession(apiKey, sessionId)
      this.session.connect(token, (err) => {
        if (err) {
          errorHandler(err)
          return
        }
        console.log('Connected to session', sessionId)
      })
      this.session.on('signal:agentConnected', (data) => {
        console.log('Agentconnected', data)
        this.agentConnected = true
      })
      this.session.on('signal:hold', () => {
        this.agentConnected = false
        // this.agentStream = null
      })
      this.session.on('signal:unhold', () => {
        this.agentConnected = true
      })
      this.session.on('signal:endCall', () => {
        this.endCallHandler()
      })
      this.session.on('streamCreated', (event) => {
        console.log('Stream created', event.stream)
        this.agentStream = event.stream
      })
      this.session.on('streamDestroyed', (event) => {
        this.agentStream = null
        this.agentConnected = false
        console.log('Stream destroyed')
      })
      this.session.on('signal:msg', function (event) {
        self.messages.push(event.data);
        self.scrollToBottom();
      });
      this.session.on('signal:deleteMessage', function (event) {
        const messageIdToDelete = event.data;
        const updatedMessages = self.messages.filter(message => message.id !== messageIdToDelete);
        self.messages = updatedMessages;
        self.scrollToBottom();
      });
    },
    async scrollToBottom() {
      this.$nextTick(() => {
        const lastMessageElement = this.$el.querySelector('.message-container > div:last-child');
        if (lastMessageElement) {
          lastMessageElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
          setTimeout(() => {
            const additionalScroll = 200; // Píxeles adicionales que quieres añadir
            const messageContainer = this.$el.querySelector('.message-container');
            if (messageContainer) {
              messageContainer.scrollTop += additionalScroll;
            }
          }, 100); // Ajusta el timeout si es necesario para asegurar que se aplique después de scrollIntoView
        }
      });
    },
    async sendMessage() {
      let self = this;

      let message = {
        id: this.getIdMessage(),
        role: "USER",
        message: self.newMessage,
        email: self.interactive.interactiveUser.email,
      }

      this.session.signal({
        type: 'msg',
        data: message
      }, function (error) {
        if (error) {
          console.log('Error sending signal:', error.name, error.message);
        } else {
          self.newMessage = '';
        }
      });
    },
    getIdMessage() {
      return Date.now().toString() + "-" + this.interactive.interactiveUser.email;
    },
    async getPublic(evt) {
      evt.preventDefault();
      let self = this;
      this.$awn.asyncBlock(
        interactiveService.getPublic(this.interactiveId, this.code, this.email),
        (response) => {
          if (response) {
            self.interactive = response.data;
            if(self.interactive.interactiveUser.banned){
              self.$router.push({ name: "public.signin" });
            }else{
              self.otConnect(self.interactive.apiKey, self.interactive.opentokSessionId, self.interactive.interactiveUser.tokenOpentok);
              self.$bvModal.hide("modal-interactive-user-code");
            }
          }
        },
        (error) => {

          self.$swal(
            "Error en el email/código",
            "Introduzca de nuevo el email/código"
          );

        },
        " "
      );
    },
    async getAuthentication() {
      return localStorage.getItem('authorization');
    },
    async getLogoOrganization() {
      let self = this;

      organizationService.findLogo(this.$route.query.organization).then(
        (response) => {
          if (response) {
            self.getLogo(response.data);
          }
        }).catch(
          (error) => {
            utilsService.auditErrorFrontent({
              info: "organizationService.findLogo",
              module: "view-pages-recipe",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                organization: this.$route.query.organization
              })
            });
          }
        );
    },
    async getLogo(uuid) {
      let self = this;
      utilsService
        .getFile(uuid)
        .then((response) => {
          if (response) {
            self.defaultAvatarLogo = false;
            self.fileLogo = response.data.data;
          } else {
            self.defaultAvatarLogo = true;
            self.fileLogo = require("../../assets/images/logo.png");
          }
        })
        .catch(function (error) {
          self.defaultAvatarLogo = true;
          self.fileLogo = require("../../assets/images/logo.png");
        });
    },
    async errorHandler(err) {
      console.log('Error', err)
    }
  },
  beforeDestroy() {
    if (this.session && this.session.isConnected()) {
      console.log('Disconnecting from session', this.session.sessionId)
      this.session.disconnect()
    }
  },
};
</script>
